import React from 'react';
import { images } from '../../constants'
import './Footer.css';
import { FiFacebook } from 'react-icons/fi';

const Footer = () => (
  <div className="app__footer section__padding">
    <div className="app__footer-container">
      <div className="app__footer-links_contact">
        <h1 className="app__footer-headtext">Contact</h1>
        <p className="p__opensans">PO Box 754 Orion, Il 61273</p>
        <div className="app__footer-links_icons">
          <a href="https://www.facebook.com/profile.php?id=100064434502599" target="_blank" rel="noopener noreferrer"> <FiFacebook /> </a>
        </div>
        <p className="p__opensans"> </p>
      </div>
      <div className="app__footer-links_logo">
        <a href="/">  <img src={images.logo} alt="footer-logo" /> </a>
        <p className="p__opensans">Come one, Come Collaborate</p>
        <img src={images.pitch} className="pitch__img" style={{ margintTop: 15 }} alt="pitch" />
      </div>
      <div className="app__footer-links_resources">
        <h1 className="app__footer-headtext">Resources</h1>
        <ul className="app__resource-link">
          <li><a href="/resources" className="p__opensans">FAQ's</a></li>
          <li><a href="/competitive" className="p__opensans">Competitive</a> </li>
          <li><a href="/recreation" className="p__opensans">Recreation</a> </li>
          <li><a href="/schedules" className="p__opensans">Field & Schedules</a> </li>
          <li><a href="https://illowa.org/" target="_blank" rel="noopener noreferrer" className="p__opensans">ILLOWA</a> </li>
          <li><a href="/refereeing" className="p__opensans">Refereeing</a> </li>
        </ul>
        <div className="app__navbar-login">
          <a href="#login" className="p__opensans" title="log in">Coaches Log in</a>
        </div>
      </div>
    </div>
    <div className="footer__copyright">
      <p className="p__opensans">2024 OSUSC. All Rights Reserved </p>
    </div>
  </div>
);

export default Footer;